(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball/assets/javascripts/ball-joker.js') >= 0) return;  svs.modules.push('/components/tur/ball/assets/javascripts/ball-joker.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
class BallJoker extends svs.tur.ball.Default {
  constructor(options) {
    options.productId = 'Joker';
    options.min = 0;
    options.max = 9;
    super(options);
    this.log = new svs.core.log.Logger('ball.joker');
  }
  classNames() {
    return ['ball-joker'];
  }
}
svs.tur.ball.Joker = BallJoker;

 })(window);